module.exports = __webpack_public_path__ + "img/yizuofei.b4e907f0.png";